import assignOffsetPagination from "@/schemas/assignOffsetPagination";
import {
    assign,
    enums,
    nullable,
    number,
    object,
    string,
    union,
} from "superstruct";

import { RewardsIconSchema } from "../../../schemas/RewardsIconSchema";
import { RewardsDiscountExtraInfoRewardSchema } from "../../../schemas/RewardsRewardSchemas/RewardsDiscountRewardSchema";
import { RewardsFreeProductRewardSchema } from "../../../schemas/RewardsRewardSchemas/RewardsFreeProductRewardSchema";
import { RewardsGiftCardRewardSchema } from "../../../schemas/RewardsRewardSchemas/RewardsGiftCardRewardSchema";
import { RewardsPointsRewardSchema } from "../../../schemas/RewardsRewardSchemas/RewardsPointsRewardSchema";
import { REWARDS_REFERRAL_STATUS } from "../constants";

export const RewardsReferralPointsRewardSchema = assign(
    RewardsPointsRewardSchema,
    object({
        spendAmountDivider: number(),
    })
);

export const RewardsReferralProgramRewardSchema = union([
    RewardsPointsRewardSchema,
    RewardsReferralPointsRewardSchema,
    RewardsDiscountExtraInfoRewardSchema,
    RewardsGiftCardRewardSchema,
    RewardsFreeProductRewardSchema,
]);

const RewardsReferralSchema = object({
    icon: nullable(RewardsIconSchema),
    rewarding: nullable(RewardsReferralProgramRewardSchema),
});

export const RewardsReferralProgramSchema = object({
    prizeForSender: RewardsReferralSchema,
    prizeForReceiver: RewardsReferralSchema,
});

export const RewardsReferralsSchema = object({
    userId: number(),
    email: nullable(string()),
    firstName: nullable(string()),
    lastName: nullable(string()),
    status: enums(Object.values(REWARDS_REFERRAL_STATUS)),
    date: string(),
});

export const RewardsReferralsResponseSchema = assignOffsetPagination(
    RewardsReferralsSchema
);
